const BaseModule = require('../../../../90_utils/base/BaseModule');
const FracturedGraph = require('../../../../80_bits/fractured-graph/script');

class FracturedGraphBlock extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$fracturedGraph = this.$el.find('.fractured-graph');
		this.fracturedGraph = new FracturedGraph(this.$fracturedGraph);

		this.$tabsContainer = this.$el.find('.tabs');
		this.$tabs = this.$tabsContainer.find('.tab');

		this.tabData = {};
		this.tabIndex = this.$tabs.find('>.is-active').index() >= 0 ? this.$tabs.find('>.is-active').index() : 0;

		this.isFirstBuild = true;
	}

	// basemodule methods

	_domReady(){
		this._rebuild();
	}

	_addListeners(){
		this.$tabs.on('click', this._onTabClick.bind(this));
	}
	_removeListeners(){ }

	// listener methods

	_onTabClick(e){

		let $target = $(e.currentTarget);
		this._rebuild($target.index());

		e.preventDefault();
	}

	//

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){

	}
	_resize(){}

	// graph construction

	_rebuild(newIndex){

		if(typeof(newIndex) === 'undefined'){ newIndex = this.tabIndex; }

		if(this.isFirstBuild || (newIndex >= 0 && newIndex < this.$tabs.length && newIndex !== this.tabIndex)){

			this.$tabs.removeClass('is-active');
			this.$tabs.eq(newIndex).addClass('is-active');

			this.tabIndex = newIndex;

			this._retrieveData();
			this._rebuildFrame();
		}
	}

	_retrieveData(){

		let $curTab = this.$tabs.eq(this.tabIndex);
		let $tabData = $curTab.find('.tab-data');

		this.tabData = {
			maxValue: $tabData.attr('data-max-value')
		};

		// center

		let $centerData = $tabData.find('.center');

		this.tabData.center = {
			value: $centerData.attr('data-value'),
			unit: $centerData.attr('data-unit'),
			subheader: $centerData.attr('data-subheader'),
			supheader: $centerData.attr('data-supheader')
		}

		// frame

		let $frameData = $tabData.find('.frame');

		if($frameData.length){

			this.tabData.frame = {
				title: $frameData.attr('data-title'),
				supheader: $frameData.attr('data-supheader'),
				subheader: $frameData.attr('data-subheader'),
				expandedCaption: $frameData.attr('data-expanded-caption')
			}
		}

		// data points

		let $dataPoints = $tabData.find('.data-point');
		this.tabData.dataPoints = [];

		$dataPoints.each((index, value) => {

			let $dataPoint = $(value);

			this.tabData.dataPoints.push({
				label: $dataPoint.attr('data-label'),
				subheader: $dataPoint.attr('data-subheader'),
				value: $dataPoint.attr('data-value')
			});
		});
	}

	_rebuildGraph(){
		if(this.tabData && this.tabData.dataPoints.length){
			this.fracturedGraph.swapData(this.tabData);
		}
	}

	_rebuildFrame(){

		if(this.tabData && this.tabData.frame){

			let frame = this.tabData.frame;
			let $elements = this.$el.find('.text-content >.title, .text-content >.supheader, .block-content >.subheader, .block-content >.disclaimer, .expanded-caption-wrapper, .fractured-graph');

			TweenMax.staggerTo($elements, 0.2, {
				opacity: 0,
				ease: 'fade'
			}, 0.05, ()=>{
				this.$el.find('.text-content >.title').html(frame.title || '');
				this.$el.find('.text-content >.supheader').html(frame.supheader || '');
				this.$el.find('.block-content >.subheader').html(frame.subheader || '');

				if(frame.expandedCaption){
					this.$el.find('.expanded-caption-wrapper').removeClass('is-hidden');
					this.$el.find('.expanded-caption .caption').html(frame.expandedCaption || '');
				}
				else {
					this.$el.find('.expanded-caption-wrapper').addClass('is-hidden');
				}

				this._rebuildGraph();

				let $elements = this.$el.find('.text-content >.title, .text-content >.supheader, .block-content >.subheader, .block-content >.disclaimer .expanded-caption-wrapper, .fractured-graph');

				TweenMax.staggerTo($elements, 0.4, {
					opacity: 1,
					ease: 'fade',
					clearProps: 'opacity'
				});
			})
		}
	}

	_showNewGraph(){

	}

	_hideOldGraph(){

	}
}

module.exports = FracturedGraphBlock;
